module.exports = __webpack_public_path__ + "images/quilty_coverage_updated.png";